import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { IntlContext } from "@jutro/locale";
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import moment from 'moment';
import metadata from './ClaimPaymentsTable.metadata.json5';



const renderFormattedCurrencyField = (item, index) => {
    return (
        <div >
            <CurrencyField
                id={`currency_${index}`}
                value={item}
                readOnly
                hideLabel
            />
        </div>
    );
};



const getFormattedCurrency = (item, index, property) => {
    if(item[property.id]!==undefined){
        return renderFormattedCurrencyField(item[property.id]);
    }
    return ' ';
    
};

const getCell = (item, index, property) => {
    if(item[property.id]!==undefined){
        return item[property.id];
    }
    return ' ';
   
};



const getStatus = (item, index, property) => {
    
    if(item.status==='issued')
    {
       
        return 'Issued'
    }
    if(item.status==='requesting')
    {
        return 'Requesting'
    }
    if(item.status==='requested')
    {
        return 'Requested'
    }
    if(item.status==='awaitingsubmission')
    {
        return 'Awaiting Submission'
    }
    return item[property.id];
    
   
};

function ClaimPaymentsTable(props) {
    
    const {
        data
        
    } = props;

    

    const intl = useContext(IntlContext);

    const getFormattedDate = useCallback((item, index, property) => {
        
        if(item[property.id]!==undefined)
        {
            // return intl.formatDate(new Date(item[property.id]), { year: 'numeric', month: 'numeric', day: 'numeric' });
            return moment(item[property.id]).format('MM/DD/YYYY');
        }
        return ' ';
        
       
    }, []);

    const getServiceDate=useCallback((item,index,property)=>{
        
        const  startDate= moment(item.servicePeriodStartDate).format('MM/DD/YYYY');
        const endDate = moment(item.servicePeriodEndDate).format('MM/DD/YYYY');
        return `${startDate} - ${endDate}`;
     
    
    },[]);

    const overrideProps = {
        tablePaymentScheduleDetail: {
            data: data.sort((a,b)=>{return new Date(b.scheduledDate)-new Date(a.scheduledDate)})
        },
        paymentServiceDate:{
            sortable:false,
        },
        paymentStatus:{
            sortable:false
        }
       
    };

    const resolvers = {
        //  resolveClassNameMap: styles,
        resolveCallbackMap: {
            getFormattedDate,
            getFormattedCurrency,
            getCell,
            getServiceDate,
            getStatus
            
            
        }
    };

    return <MetadataContent uiProps={metadata.componentContent} overrideProps={overrideProps} {...resolvers} />;
}

ClaimPaymentsTable.propTypes = {
    invoiceSummary: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectedInvoices: PropTypes.arrayOf(PropTypes.string),
    onUpdateSelectedInvoices: PropTypes.func,
    showSelect: PropTypes.bool,
    showPaidDate: PropTypes.bool
};

ClaimPaymentsTable.defaultProps = {
    selectedInvoices: [],
    onUpdateSelectedInvoices: undefined,
    showSelect: false,
    showPaidDate: false
};

export default ClaimPaymentsTable;